export const updateSpeedManagmentService =
  (fetch) => async (speedManagment) => {
    try {
      const response = await fetch({
        url: `/api/v1/gestion-velocidad/${speedManagment.id}`,
        method: "put",
        body: speedManagment,
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
